import tw from 'twin.macro';
import { Swiper } from 'swiper/react';

export const StyledSwiper = tw(Swiper)`cursor-pointer`;
